import type { Components } from '@mildang/mui';

const createBadge = (): Components => ({
  MuiBadge: {
    styleOverrides: {
      root: {
        '& .MuiBadge-dot': {
          minWidth: 3,
          height: 3,
          transform: 'translate(100%, 0)',
        },
      },
    },
  },
});

export default createBadge;
